import styled from 'styled-components';

export const StyledTutorialArrow = styled.div`
  position: fixed;
  width: 4rem;
  height: 4rem;
  z-index: 201;
  animation: pulsate 1.5s infinite;

  img {
    width: 100%;
    height: 100%;
  }
`;
